<template>
	<v-navigation-drawer
		id="core-navigation-drawer"
		v-model="drawer"
		:right="$vuetify.rtl"
		mobile-breakpoint="960"
		app
		permanent
		:width="drawer ? '300' : '60'"
		v-bind="$attrs"
		color="primary2">
		<template #prepend>
			<span v-if="drawer" class="d-flex justify-center align-center my-6 mr-5">
				<img :src="logoDrawer" class="mb-1" />
				<div class="d-flex align-center">
					<span class="font-weight-bold font-size24 ml-2 white--text">Wellness</span>
					<span class="font-weight-bold font-size24 ml-2 white--text">Metric</span>
				</div>
			</span>
			<span v-else class="d-flex justify-center align-center my-6">
				<img :src="logoDrawer" />
			</span>
		</template>
		<div style="height: 100%" class="d-flex flex-column">
			<v-list nav dense density="compact" class="overflow-y-auto flex-grow-1">
				<template v-if="drawer">
					<template v-for="(item, indexItem) in items">
						<!-- 📂 Grouped items -->
						<v-list-group
							:key="'group-' + indexItem"
							v-if="item.children && item.children.length > 0"
							:append-icon="drawer ? 'mdi-chevron-down' : ''"
							class="no-padding-header">
							<template #appendIcon>
								<v-icon color="white">mdi-chevron-down</v-icon>
							</template>
							<template #activator>
								<v-list-item>
									<v-list-item-icon color="white" class="d-flex align-center">
										<img :src="item.icon" height="18px" class="ml-1" />
									</v-list-item-icon>
									<v-list-item-title class="text-start text-body-2">
										<span class="white-icon">{{ item.title }}</span>
									</v-list-item-title>
								</v-list-item>
							</template>

							<v-list-item
								v-for="child in item.children"
								:key="child.title"
								:to="child.path"
								@click="child.clickEvent && child.clickEvent()"
								:class="['layout-slider-item', drawerClass(child), { 'selected-item': child.isSelected }]"
								link
								class="pl-5">
								<v-list-item-icon class="d-flex align-center">
									<img :src="child.icon" height="18px" class="ml-1" />
								</v-list-item-icon>
								<v-list-item-title class="text-white text-left">{{ child.title }}</v-list-item-title>
							</v-list-item>
						</v-list-group>

						<!-- 📄 Single items -->
						<v-list-item
							v-else
							:key="'item-' + indexItem"
							:to="item.path"
							@click="item.clickEvent && item.clickEvent()"
							:class="['layout-slider-item', drawerClass(item), { 'selected-item': item.isSelected }]"
							link>
							<v-list-item-icon color="white" class="d-flex align-center">
								<img :src="item.icon" height="18px" class="ml-1" />
							</v-list-item-icon>
							<v-list-item-title class="text-start text-body-2">
								<span class="white-icon">{{ item.title }}</span>
							</v-list-item-title>
						</v-list-item>
					</template>
				</template>
				<template v-else>
					<template v-for="item in items">
						<v-list-group
							v-if="item.children && item.children.length > 0"
							append-icon=""
							:key="'group-' + item.title"
							class="no-padding-header">
							<template #activator>
								<v-tooltip right>
									<template #activator="{ on, attrs }">
										<v-list-item class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
											<v-list-item-icon class="mx-0 d-flex align-center justify-center" style="width: 28px">
												<img :src="item.icon" height="18px" />
											</v-list-item-icon>
										</v-list-item>
									</template>
									<span>{{ item.title }}</span>
								</v-tooltip>
							</template>
							<template>
								<v-tooltip right v-for="child in item.children" :key="child.title">
									<template #activator="{ on, attrs }">
										<v-list-item
											:class="[{ 'selected-item': $router.history.current.path === child.path }]"
											class="d-flex align-center justify-center"
											v-bind="attrs"
											v-on="on"
											:to="child.path"
											link>
											<v-list-item-icon class="mx-0 d-flex align-center justify-center">
												<img :src="child.icon" height="18px" />
											</v-list-item-icon>
										</v-list-item>
									</template>
									<span>{{ child.title }}</span>
								</v-tooltip>
							</template>
						</v-list-group>
						<v-tooltip v-else right :key="'item-' + item.title">
							<template #activator="{ on, attrs }">
								<v-list-item
									:to="item.path"
									:class="['layout-slider-item', drawerClass(item), { 'selected-item': item.isSelected }]"
									class="d-flex align-center justify-center"
									link>
									<v-list-item-icon
										color="white"
										class="mx-0 d-flex align-center justify-center"
										v-bind="attrs"
										v-on="on">
										<img :src="item.icon" height="18px" />
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
					</template>
				</template>
				<!-- BILLINGS Group -->
				<v-list-group
					:append-icon="drawer ? 'mdi-chevron-down' : ''"
					class="no-padding-header"
					v-if="roleName === 'ORGANIZATION_ADMIN' || roleName === 'HOSPITAL_ADMIN'">
					<template #appendIcon>
						<v-icon v-if="drawer" color="white">mdi-chevron-down</v-icon>
					</template>
					<template #activator>
						<template v-if="drawer">
							<v-list-item>
								<v-list-item-icon class="custom-list-group d-flex align-center">
									<img :src="billings[0]?.icon || ''" height="18px" class="ml-1" />
								</v-list-item-icon>
								<v-list-item-title class="white--text text-start text-body-2">
									{{ $t('Billings') }}
								</v-list-item-title>
							</v-list-item>
						</template>
						<template v-else>
							<v-tooltip right>
								<template #activator="{ on, attrs }">
									<v-list-item class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
										<v-list-item-icon class="mx-0 custom-list-group d-flex align-center">
											<img :src="billings[0]?.icon || ''" height="18px" />
										</v-list-item-icon>
									</v-list-item>
								</template>
								<span>{{ $t('Billings') }}</span>
							</v-tooltip>
						</template>
					</template>
					<template v-if="drawer">
						<v-list-item link v-for="(item, index) in billings" :key="index" class="pl-5" :to="item.path">
							<v-list-item-icon>
								<img :src="item.icon" height="18px" class="ml-1" />
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="text-white text-left">{{ item.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right v-for="(item, index) in billings" :key="index">
							<template #activator="{ on, attrs }">
								<v-list-item
									class="d-flex align-center justify-center"
									v-bind="attrs"
									v-on="on"
									:to="item.path"
									link
									:class="[{ 'selected-item': $router.history.current.path === item.path }]">
									<v-list-item-icon class="mx-0 d-flex align-center justify-center">
										<img :src="item.icon" height="18px" />
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
					</template>
				</v-list-group>
				<!-- ECP Mappings Group -->
				<v-list-group
					:append-icon="drawer ? 'mdi-chevron-down' : ''"
					class="no-padding-header"
					v-if="
						roleName === 'SYSTEM_ADMIN' ||
						roleName === 'HOSPITAL_ADMIN' ||
						roleName === 'DOCTOR' ||
						roleName === 'NURSE'
					">
					<template #appendIcon>
						<v-icon v-if="drawer" color="white">mdi-chevron-down</v-icon>
					</template>
					<template #activator>
						<template v-if="drawer">
							<v-list-item>
								<v-list-item-icon color="white" class="d-flex align-center">
									<img :src="ecpLogoWhite" height="18px" class="ml-1" />
								</v-list-item-icon>
								<v-list-item-title class="text-start text-body-2">
									<span class="white--text">{{ $t('ECP-mapping') }}</span>
								</v-list-item-title>
							</v-list-item>
						</template>
						<template v-else>
							<v-tooltip right>
								<template #activator="{ on, attrs }">
									<v-list-item class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
										<v-list-item-icon class="mx-0 d-flex align-center justify-center">
											<img :src="ecpLogoWhite" height="18px" />
										</v-list-item-icon>
									</v-list-item>
								</template>
								<span>{{ $t('ECP-mapping') }}</span>
							</v-tooltip>
						</template>
					</template>
					<template v-if="drawer">
						<v-list-item
							link
							v-for="item in ECPMapping"
							:key="item.title"
							:to="item.path"
							class="pl-5"
							:class="['layout-slider-item', drawerClass(item), { 'selected-item': item.isSelected }]">
							<v-list-item-icon class="d-flex align-center">
								<img :src="item.icon" height="18px" class="ml-1" style="filter: brightness(0) invert(1)" />
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="text-white text-left">{{ item.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right v-for="item in ECPMapping" :key="item.title">
							<template #activator="{ on, attrs }">
								<v-list-item
									v-bind="attrs"
									v-on="on"
									:to="item.path"
									link
									class="d-flex align-center justify-center"
									:class="[{ 'selected-item': $router.history.current.path === item.path }]">
									<v-list-item-icon class="mx-0 d-flex align-center justify-center">
										<img :src="item.icon" height="18px" style="filter: brightness(0) invert(1)" />
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
					</template>
				</v-list-group>
				<!-- PCC Mapping -->
				<v-list-group
					v-if="
						roleName === 'SYSTEM_ADMIN' ||
						roleName === 'HOSPITAL_ADMIN' ||
						roleName === 'DOCTOR' ||
						roleName === 'NURSE'
					"
					:append-icon="drawer ? 'mdi-chevron-down' : ''"
					class="no-padding-header long-text-group">
					<template #appendIcon>
						<v-icon v-if="drawer" color="white">mdi-chevron-down</v-icon>
					</template>
					<template #activator>
						<template v-if="drawer">
							<v-list-item>
								<v-list-item-icon color="white" class="d-flex align-center">
									<v-tooltip bottom color="primary">
										<template v-slot:activator="{ on, attrs }">
											<span v-bind="attrs" v-on="on" class="logo-wrapper">
												<v-badge :color="pccRateLimitColor.color" dot class="outside-badge">
													<img :src="pccLogoWhite" height="18" class="ml-1" />
												</v-badge>
											</span>
										</template>
										<span class="d-flex text-left">
											{{ pccRateLimitColor.text }}
											<br />
											{{ pccRateLimitColor.daily }}
											<br />
											{{ pccRateLimitColor.minute }}
										</span>
									</v-tooltip>
								</v-list-item-icon>
								<v-list-item-title class="text-start text-body-2">
									<span class="white--text">{{ $t('pcc-mapping') }}</span>
								</v-list-item-title>
							</v-list-item>
						</template>
						<template v-else>
							<v-tooltip right>
								<template #activator="{ on, attrs }">
									<v-list-item class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
										<v-list-item-icon class="mx-0 d-flex align-center justify-center">
											<v-tooltip bottom color="primary">
												<template v-slot:activator="{ on, attrs }">
													<span v-bind="attrs" v-on="on" class="logo-wrapper">
														<v-badge :color="pccRateLimitColor.color" dot class="outside-badge">
															<img :src="pccLogoWhite" height="18" class="ml-1" />
														</v-badge>
													</span>
												</template>

												<span class="d-flex text-left">
													{{ pccRateLimitColor.text }}
													<br />
													{{ pccRateLimitColor.daily }}
													<br />
													{{ pccRateLimitColor.minute }}
												</span>
											</v-tooltip>
										</v-list-item-icon>
									</v-list-item>
								</template>
								<span>{{ $t('pcc-mapping') }}</span>
							</v-tooltip>
						</template>
					</template>
					<template v-if="drawer">
						<v-list-item
							link
							v-for="item in PCCMapping"
							:key="item.title"
							:to="item.path"
							class="pl-5"
							:class="['layout-slider-item', drawerClass(item), { 'selected-item': item.isSelected }]">
							<v-list-item-icon class="d-flex align-center">
								<img :src="item.icon" height="18px" class="ml-1" style="filter: brightness(0) invert(1)" />
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="text-white text-left">{{ item.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right v-for="item in PCCMapping" :key="item.title">
							<template #activator="{ on, attrs }">
								<v-list-item
									v-bind="attrs"
									v-on="on"
									:to="item.path"
									link
									class="d-flex align-center justify-center"
									:class="[{ 'selected-item': $router.history.current.path === item.path }]">
									<v-list-item-icon class="mx-0 d-flex align-center justify-center">
										<img :src="item.icon" height="18px" style="filter: brightness(0) invert(1)" />
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
					</template>
				</v-list-group>
				<!-- Terra Mapping Group -->
				<!-- <v-list-group
					v-if="!['SYSTEM_ADMIN', 'SYSTEM_USER', 'PARTNER'].includes(roleName)"
					:append-icon="drawer ? 'mdi-chevron-down' : ''"
					class="no-padding-header">
					<template #appendIcon>
						<v-icon v-if="drawer" color="white">mdi-chevron-down</v-icon>
					</template>
					<template #activator>
						<template v-if="drawer">
							<v-list-item>
								<v-list-item-icon color="white" class="d-flex align-center">
									<v-icon size="18" color="white" class="ml-1">mdi-alpha-t-box</v-icon>
								</v-list-item-icon>
								<v-list-item-title class="text-start text-body-2">
									<span class="white--text">{{ $t('terra-integration') }}</span>
								</v-list-item-title>
							</v-list-item>
						</template>
						<template v-else>
							<v-tooltip right>
								<template #activator="{ on, attrs }">
									<v-list-item class="d-flex align-center justify-center" v-bind="attrs" v-on="on">
										<v-list-item-icon class="mx-0 d-flex align-center justify-center">
											<v-icon size="18" color="white">mdi-alpha-t-box</v-icon>
										</v-list-item-icon>
									</v-list-item>
								</template>
								<span>{{ $t('terra-integration') }}</span>
							</v-tooltip>
						</template>
					</template>
					<template v-if="drawer">
						<v-list-item
							link
							v-for="item in TerraIntegration"
							:key="item.title"
							:to="item.path"
							class="pl-5"
							:class="[{ 'selected-item': $router.history.current.path === item.path }]">
							<v-list-item-icon class="d-flex align-center">
								<v-icon size="18" color="white" class="ml-1">{{ item.icon }}</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title class="text-white text-left">{{ item.title }}</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right v-for="item in TerraIntegration" :key="item.title">
							<template #activator="{ on, attrs }">
								<v-list-item
									:class="[{ 'selected-item': $router.history.current.path === item.path }]"
									class="d-flex align-center justify-center"
									v-bind="attrs"
									v-on="on"
									:to="item.path"
									link>
									<v-list-item-icon class="mx-0 d-flex align-center justify-center">
										<v-icon size="18" color="white">{{ item.icon }}</v-icon>
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ item.title }}</span>
						</v-tooltip>
					</template>
				</v-list-group> -->
				<!-- Device template -->
				<template v-if="roleName === 'SYSTEM_ADMIN' || roleName === 'SYSTEM_USER'">
					<template v-if="drawer">
						<v-list-item
							link
							to="/device-template"
							:class="[{ 'selected-item': $router.history.current.path === '/device-template' }]">
							<v-list-item-icon color="white" class="d-flex align-center">
								<v-icon color="white">mdi-cellphone-link</v-icon>
							</v-list-item-icon>
							<v-list-item-title class="text-start text-body-2">
								<span class="white--text">{{ $t('device-template') }}</span>
							</v-list-item-title>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right>
							<template #activator="{ on, attrs }">
								<v-list-item
									:class="[{ 'selected-item': $router.history.current.path === '/device-template' }]"
									class="d-flex align-center justify-center"
									to="/device-template"
									link>
									<v-list-item-icon class="mx-0 d-flex align-center justify-center" v-bind="attrs" v-on="on">
										<v-icon color="white">mdi-cellphone-link</v-icon>
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ $t('device-template') }}</span>
						</v-tooltip>
					</template>
				</template>
				<!-- OnBoarding dialog -->
				<template v-if="checkRole && userObject.userData.isSequoiaUser && userObject.userData.isSequoiaUser === true">
					<template v-if="drawer">
						<v-list-item @click="openOnBoardingDialog">
							<v-list-item-icon color="white" class="d-flex align-center">
								<v-icon color="white">mdi-auto-fix</v-icon>
							</v-list-item-icon>
							<v-list-item-title class="text-start text-body-2">
								<span class="white-icon">{{ $t('add-location-wizard') }}</span>
							</v-list-item-title>
						</v-list-item>
					</template>
					<template v-else>
						<v-tooltip right>
							<template #activator="{ on, attrs }">
								<v-list-item
									v-bind="attrs"
									v-on="on"
									@click="openOnBoardingDialog"
									class="d-flex align-center justify-center">
									<v-list-item-icon class="mx-0 d-flex align-center justify-center">
										<v-icon color="white" size="18">mdi-auto-fix</v-icon>
									</v-list-item-icon>
								</v-list-item>
							</template>
							<span>{{ $t('add-location-wizard') }}</span>
						</v-tooltip>
					</template>
				</template>
			</v-list>
			<v-list nav dense v-if="roleName != 'PARTNER'">
				<!-- Documents -->
				<template v-if="drawer">
					<v-list-item
						link
						to="/releaseNotesAndManuals"
						:class="[{ 'selected-item': $router.history.current.path === '/releaseNotesAndManuals' }]">
						<v-list-item-icon color="white" class="d-flex align-center">
							<img :src="supportWhite" height="24px" class="ml-1" />
						</v-list-item-icon>
						<v-list-item-title class="text-start text-body-2">
							<span class="white--text">{{ $t('release-notes-and-manuals') }}</span>
						</v-list-item-title>
					</v-list-item>
				</template>
				<template v-else>
					<v-tooltip right>
						<template #activator="{ on, attrs }">
							<v-list-item
								:class="[{ 'selected-item': $router.history.current.path === '/releaseNotesAndManuals' }]"
								class="d-flex align-center justify-center"
								to="/releaseNotesAndManuals"
								link>
								<v-list-item-icon class="mx-0 d-flex align-center justify-center" v-bind="attrs" v-on="on">
									<img :src="supportWhite" height="18px" />
								</v-list-item-icon>
							</v-list-item>
						</template>
						<span>{{ $t('release-notes-and-manuals') }}</span>
					</v-tooltip>
				</template>
				<!-- Only Doctors and Nurses can change the facility -->
				<v-list-item v-if="checkRole && drawer" class="select-hospital px-0" @click="dialog = true">
					<template v-if="drawer">
						<v-btn color="primary" style="width: 100%">
							<div class="d-flex align-center">
								<v-img class="mr-1" :src="HospitalWhite" max-width="20" />
								<span style="font-size: 13px; text-wrap: wrap">
									{{ userObject.userData?.hospitalAssignedData?.hospitalName }}
								</span>
							</div>
						</v-btn>
					</template>
				</v-list-item>
				<template v-else-if="checkRole">
					<v-tooltip right>
						<template #activator="{ on, attrs }">
							<v-list-item v-bind="attrs" v-on="on" class="select-hospital" @click="dialog = true">
								<v-img :src="HospitalWhite" max-width="25" />
							</v-list-item>
						</template>
						<span>{{ $t('select-hospital') }}</span>
					</v-tooltip>
				</template>
			</v-list>

			<OnboardingWizardDialog v-if="showWizard" :showDialog="showWizard" @closeWizardDialog="closeOnBoardingDialog" />
		</div>

		<BranchSelectorDialog v-if="dialog" :dialog="dialog" @reload="reloadComponent" @false="dialog = false" />
	</v-navigation-drawer>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import {
	logoDrawer,
	logoWithName,
	duplicate,
	dashboardWhite,
	devicesWhite,
	medicalNote,
	usersWhite,
	doctorWhite,
	hospitalWhite,
	organizationsWhite,
	billWhite,
	supportWhite,
	verifireWhite,
	mentalHealthWhite,
	medicalTeamWhite,
	logs,
	licence,
	calendarEventWhite,
	chartBar,
	pccLogoWhite,
	ecpLogoWhite,
	building,
	medicalTeamBlack,
	patientBlack,
	tabletWhite,
	//  clipboardTextWhite,
} from '@/assets';
import BranchSelectorDialog from '../dialogs/BranchSelectorDialog.vue';
import OnboardingWizardDialog from '../dialogs/OnboardingWizardDialog.vue';
import { showErrorAlert } from '../../utils/utilities';

export default {
	name: 'DashboardCoreDrawer',
	components: { BranchSelectorDialog, OnboardingWizardDialog },
	data: () => ({
		logoWithName: logoWithName,
		mentalHealthWhite: mentalHealthWhite,
		HospitalWhite: hospitalWhite,
		DevicesWhite: devicesWhite,
		Devices: devicesWhite,
		logoDrawer: logoDrawer,
		supportWhite: supportWhite,
		pccLogoWhite: pccLogoWhite,
		ecpLogoWhite: ecpLogoWhite,
		dialog: false,
		licence: licence,
		smallScreen: false,
		showWizard: false,
		pccRateLimitColor: '',
	}),
	computed: {
		...mapState(['pageSize']),
		...mapGetters({
			roleName: 'authentication/getRole',
			specialization: 'authentication/getSpecialization',
			userObject: 'authentication/userObject',
		}),
		checkRole () {
			return this.roleName === 'DOCTOR' || this.roleName === 'NURSE';
		},
		drawer: {
			get () {
				return this.$store.state.drawer;
			},
			set (val) {
				this.$store.commit('SET_DRAWER', val);
			},
		},
		billings () {
			switch (this?.roleName) {
				case 'ORGANIZATION_ADMIN':
				case 'HOSPITAL_ADMIN':
					return [
						{ title: this.$t('billing-reports'), icon: billWhite, path: '/billings' },
						{ title: this.$t('BillingsAuthorizationTemplates'), icon: duplicate, path: '/billingsettings' },
						{ title: this.$t('UserBillingsAuthorization'), icon: billWhite, path: '/UserBillingSettings' },
					];
				default:
					return [];
			}
		},
		ECPMapping () {
			switch (this?.roleName) {
				case 'SYSTEM_USER':
				case 'SYSTEM_ADMIN':
					return [
						{ title: this.$t('organization-mapping'), icon: hospitalWhite, path: '/organizationMapping' },
						{ title: this.$t('location-mapping'), icon: building, path: '/locationMapping' },
						{ title: this.$t('staff-mapping'), icon: medicalTeamBlack, path: '/medicalStaffMapping' },
						{ title: this.$t('resident-mapping'), icon: patientBlack, path: '/residentMapping' },
					];
				case 'ORGANIZATION_ADMIN':
					return [
						{ title: this.$t('location-mapping'), icon: building, path: '/locationMapping' },
						{ title: this.$t('staff-mapping'), icon: medicalTeamBlack, path: '/medicalStaffMapping' },
					];
				case 'HOSPITAL_ADMIN':
					return [
						{ title: this.$t('staff-mapping'), icon: medicalTeamBlack, path: '/medicalStaffMapping' },
						{ title: this.$t('resident-mapping'), icon: patientBlack, path: '/residentMapping' },
					];
				case 'DOCTOR':
				case 'NURSE':
					return [
						{ title: this.$t('staff-mapping'), icon: medicalTeamBlack, path: '/medicalStaffMapping' },
						{ title: this.$t('resident-mapping'), icon: patientBlack, path: '/residentMapping' },
					];
				default:
					return [];
			}
		},
		PCCMapping () {
			// switch (this?.roleName) {
			switch (this?.roleName) {
				case 'SYSTEM_USER':
				case 'SYSTEM_ADMIN':
					return [
						{ title: this.$t('organization-mapping'), icon: hospitalWhite, path: '/organizationMappingPcc' },
						// { title: this.$t('location-mapping'), icon: building, path: '/pccLocationMapping' },
					];
				// case 'ORGANIZATION_ADMIN':
				// 	return [
				// 		{ title: this.$t('location-mapping'), icon: building, path: '/pccLocationMapping' },
				// 		{ title: this.$t('staff-mapping-pcc'), icon: medicalTeamBlack, path: '/medicalStaffMappingPcc' },
				// 	];
				case 'HOSPITAL_ADMIN':
					return [
						// { title: this.$t('staff-mapping-pcc'), icon: medicalTeamBlack, path: '/medicalStaffMappingPcc' },
						{ title: this.$t('resident-mapping'), icon: patientBlack, path: '/residentMappingPcc' },
					];
				case 'DOCTOR':
				case 'NURSE':
					return [
						// { title: this.$t('staff-mapping-pcc'), icon: medicalTeamBlack, path: '/medicalStaffMappingPcc' },
						{ title: this.$t('resident-mapping'), icon: patientBlack, path: '/residentMappingPcc' },
					];
				default:
					return [];
			}
		},
		TerraIntegration () {
			return [{ title: this.$t('patient-integration'), icon: 'mdi-alpha-t-box', path: '/terraPatientIntegration' }];
		},
		items () {
			switch (this?.roleName) {
				case 'SYSTEM_USER':
				case 'SYSTEM_ADMIN':
					return [
						{
							title: this.$t('system-admin-dashboard'),
							icon: dashboardWhite,
							path: '/dashboardsystemadmin',
						},
						{
							title: this.$t('organizations'),
							icon: organizationsWhite,
							path: '/organizations',
						},
						{
							title: this.$t('hospitals'),
							icon: hospitalWhite,
							path: '/offices',
						},
						{
							title: this.$t('admins'),
							icon: usersWhite,
							path: '/admins',
						},
						{
							title: this.$t('support'),
							icon: supportWhite,
							path: '/support',
						},
						{
							title: this.$t('verifier'),
							icon: verifireWhite,
							path: '/verifier',
						},
						// {
						// 	title: this.$t('SA_Reports'),
						// 	icon: verifireWhite,
						// 	path: '/sareports',
						// },
						{
							title: this.$t('invoices'),
							icon: verifireWhite,
							path: '/invoices',
						},
						// {
						//   title: this.$t('resident-mapping'),
						//   icon: convertArrows,
						//   path: '/residentMapping',
						// },
						// {
						//   title: this.$t('staff-mapping'),
						//   icon: convertArrows,
						//   path: '/medicalStaffMapping',
						// },
						{
							title: this.$t('logs'),
							icon: logs,
							path: '/logs',
						},
						// {
						// 	title: this.$t('licenses'),
						// 	icon: licence,
						// 	path: '/licenses',
						// },
						{
							title: this.$t('inventory'),
							icon: calendarEventWhite,
							path: '',
							children: [
								{
									title: this.$t('item-catalog'),
									icon: calendarEventWhite,
									path: '/itemCatalog',
								},
								{
									title: this.$t('consumable-catalog'),
									icon: chartBar,
									path: '/consumableCatalog',
								},
								{
									title: this.$t('items'),
									icon: calendarEventWhite,
									path: '/inventoryItems',
								},
								{
									title: this.$t('consumables'),
									icon: chartBar,
									path: '/inventoryConsumables',
								},
							],
						},
						{
							title: this.$t('tablets'),
							icon: tabletWhite,
							path: '/tablets',
						},
					];
				case 'PARTNER':
					return [
						{
							title: this.$t('billing-reports'),
							icon: billWhite,
							path: '/partnerBillingReports',
						},
					];
				case 'ORGANIZATION_ADMIN':
					// this.$store.dispatch('roles/getRoles');
					this.$store.dispatch('verifiers/getVerifiersForDomainSpecialization');
					// this.$store.dispatch('verifiers/getVerifiersForDomainSurveyType');
					// this.$store.dispatch('verifiers/getVerifiersForDomainMentalHealth');

					if (this.userObject.userData?.organizationAssignedData?.wellnessFlagDefault) {
						return [
							{
								title: this.$t('Admin Dashboard'),
								icon: dashboardWhite,
								path: '/dashboardAdmin',
							},
							{
								title: this.$t('Organizations'),
								icon: organizationsWhite,
								path: '/organizations',
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('admins'),
								icon: usersWhite,
								path: '/admins',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('invoices'),
								icon: verifireWhite,
								path: '/invoices',
							},
							// how to show or hide this based on condition
							{
								title: this.$t('monitoring-plans'),
								icon: devicesWhite,
								path: '/monitoring',
							},
							{
								title: this.$t('medical-note-category'),
								icon: medicalNote,
								path: '/medicalNotesCategory',
							},
							// {
							// 	title: this.$t('audit-report'),
							// 	icon: clipboardTextWhite,
							// 	path: '/auditReport',
							// },
							// {
							// 	title: this.$t('licenses'),
							// 	icon: licence,
							// 	path: '/licenses',
							// },
						];
					} else {
						return [
							{
								title: this.$t('Admin Dashboard'),
								icon: dashboardWhite,
								path: '/dashboardAdmin',
							},

							{
								title: this.$t('Organizations'),
								icon: organizationsWhite,
								path: '/organizations',
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('admins'),
								icon: usersWhite,
								path: '/admins',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('invoices'),
								icon: verifireWhite,
								path: '/invoices',
							},
							{
								title: this.$t('medical-note-category'),
								icon: medicalNote,
								path: '/medicalNotesCategory',
							},
							// {
							// 	title: this.$t('audit-report'),
							// 	icon: clipboardTextWhite,
							// 	path: '/auditReport',
							// },
							// {
							// 	title: this.$t('licenses'),
							// 	icon: licence,
							// 	path: '/licenses',
							// },
						];
					}
				case 'HOSPITAL_ADMIN':
					this.$store.dispatch('roles/getRoles');
					this.$store.dispatch('verifiers/getVerifiersForDomainSpecialization');
					this.$store.dispatch('verifiers/getVerifiersForDomainSurveyType');
					this.$store.dispatch('verifiers/getVerifiersForDomainMentalHealth');
					if (this.userObject.userData.hospitalAssignedData.medicalInstitutionData.wellnessFlagDefault) {
						return [
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('assessments'),
								icon: mentalHealthWhite,
								path: '/wellnessassessments',
							},
							{
								title: this.$t('medical-note-category'),
								icon: medicalNote,
								path: '/medicalNotesCategory',
							},
							// {
							// 	title: this.$t('audit-report'),
							// 	icon: clipboardTextWhite,
							// 	path: '/auditReport',
							// },
							// {
							// 	title: this.$t('licenses'),
							// 	icon: licence,
							// 	path: '/licenses',
							// },
						];
					} else {
						return [
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('medical-note-category'),
								icon: medicalNote,
								path: '/medicalNotesCategory',
							},
							// {
							// 	title: this.$t('audit-report'),
							// 	icon: clipboardTextWhite,
							// 	path: '/auditReport',
							// },
							// {
							// 	title: this.$t('licenses'),
							// 	icon: licence,
							// 	path: '/licenses',
							// },
						];
					}
				case 'DOCTOR':
					this.$store.dispatch('roles/getRoles');
					this.$store.dispatch('verifiers/getVerifiersForDomainSpecialization');
					this.$store.dispatch('verifiers/getVerifiersForDomainSurveyType');
					this.$store.dispatch('verifiers/getVerifiersForDomainMentalHealth');
					if (this.userObject.userData.hospitalAssignedData.medicalInstitutionData.wellnessFlagDefault) {
						return [
							// {
							//   title: this.$t('dashboardIconTooltip'),
							//   icon: dashboardWhite,
							//   path: '/dashboard',
							// },
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('schedules'),
								icon: calendarEventWhite,
								path: '',
								children: [
									{
										title: this.$t('schedules'),
										icon: calendarEventWhite,
										path: '/schedules',
									},
									{
										title: this.$t('schedules-reports'),
										icon: chartBar,
										path: '/schedules-reports',
									},
								],
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('billing-reports'),
								icon: billWhite,
								path: '/billings',
							},
							// ...(this.userObject.userData.isSequoiaUser === true
							// 	? [
							// 			{
							// 				title: this.$t('audit-report'),
							// 				icon: clipboardTextWhite,
							// 				path: '/auditReport',
							// 			},
							// 	  ]
							// 	: []),
							{
								title: this.$t('assessments'),
								icon: mentalHealthWhite,
								path: '/wellnessassessments',
							},
							{
								title: this.$t('monthly-review'),
								icon: verifireWhite,
								path: '/monthlyreview',
							},
							// {
							//   title: this.$t('daily-reports'),
							//   icon: verifireWhite,
							//   path: '/dailyreports',
							// },
							// {
							// 	title: this.$t('mental-health-assignments'),
							// 	icon: mentalHealthWhite,
							// 	path: '/mentalhealthpatient',
							// },
							// {
							// 	title: this.$t('licenses'),
							// 	icon: licence,
							// 	path: '/licenses',
							// },
						];
					} else {
						return [
							// {
							//   title: this.$t('dashboardIconTooltip'),
							//   icon: dashboardWhite,
							//   path: '/dashboard',
							// },
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('schedules'),
								icon: calendarEventWhite,
								path: '',
								children: [
									{
										title: this.$t('schedules'),
										icon: calendarEventWhite,
										path: '/schedules',
									},
									{
										title: this.$t('schedules-reports'),
										icon: chartBar,
										path: '/schedules-reports',
									},
								],
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('billing-reports'),
								icon: billWhite,
								path: '/billings',
							},
							// ...(this.userObject.userData.isSequoiaUser === true
							// 	? [
							// 			{
							// 				title: this.$t('audit-report'),
							// 				icon: clipboardTextWhite,
							// 				path: '/auditReport',
							// 			},
							// 	  ]
							// 	: []),
							{
								title: this.$t('monthly-review'),
								icon: verifireWhite,
								path: '/monthlyreview',
							},
						];
					}
				case 'NURSE':
					this.$store.dispatch('roles/getRoles');
					this.$store.dispatch('verifiers/getVerifiersForDomainSpecialization');
					this.$store.dispatch('verifiers/getVerifiersForDomainSurveyType');
					this.$store.dispatch('verifiers/getVerifiersForDomainMentalHealth');
					if (this.userObject.userData.hospitalAssignedData.medicalInstitutionData.wellnessFlagDefault) {
						return [
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('schedules'),
								icon: calendarEventWhite,
								path: '',
								children: [
									{
										title: this.$t('schedules'),
										icon: calendarEventWhite,
										path: '/schedules',
									},
									{
										title: this.$t('schedules-reports'),
										icon: chartBar,
										path: '/schedules-reports',
									},
								],
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('billing-reports'),
								icon: billWhite,
								path: '/billings',
							},
							// ...(this.userObject.userData.isSequoiaUser === true
							// 	? [
							// 			{
							// 				title: this.$t('audit-report'),
							// 				icon: clipboardTextWhite,
							// 				path: '/auditReport',
							// 			},
							// 	  ]
							// 	: []),
							{
								title: this.$t('assessments'),
								icon: mentalHealthWhite,
								path: '/wellnessassessments',
							},
							{
								title: this.$t('monthly-review'),
								icon: verifireWhite,
								path: '/monthlyreview',
							},
						];
					} else {
						return [
							{
								title: this.$t('facility-dashboard'),
								icon: dashboardWhite,
								path: '/dashboardFacility',
							},
							{
								title: this.$t('schedules'),
								icon: calendarEventWhite,
								path: '',
								children: [
									{
										title: this.$t('schedules'),
										icon: calendarEventWhite,
										path: '/schedules',
									},
									{
										title: this.$t('schedules-reports'),
										icon: chartBar,
										path: '/schedules-reports',
									},
								],
							},
							{
								title: this.$t('hospitals'),
								icon: hospitalWhite,
								path: '/offices',
							},
							{
								title: this.$t('staff'),
								icon: doctorWhite,
								path: '/medicalstaff',
							},
							{
								title: this.$t('patients'),
								icon: usersWhite,
								path: '/patients',
							},
							{
								title: this.$t('medicalTeams'),
								icon: medicalTeamWhite,
								path: '/medicalteam',
							},
							{
								title: this.$t('billing-reports'),
								icon: billWhite,
								path: '/billings',
							},
							// ...(this.userObject.userData.isSequoiaUser === true
							// 	? [
							// 			{
							// 				title: this.$t('audit-report'),
							// 				icon: clipboardTextWhite,
							// 				path: '/auditReport',
							// 			},
							// 	  ]
							// 	: []),
							{
								title: this.$t('monthly-review'),
								icon: verifireWhite,
								path: '/monthlyreview',
							},
						];
					}

				default:
					return [{ title: this.$t('login'), icon: dashboardWhite, path: '/login' }];
			}
		},
	},
	async mounted () {
		await this.getPccRateLimits();
		this.pccRateLimitColor = this.getColorByPercentage();

		switch (this.pccRateLimitColor.color) {
			case 'green':
				this.pccRateLimitColor.text = `${this.$t('ok')}`;
				break;

			case 'red':
				this.pccRateLimitColor.text = this.$t('rate-limit-critical-reached');
				break;

			case 'orange':
				this.pccRateLimitColor.text = this.$t('rate-limit-warning-high');
				break;

			case 'yellow':
				this.pccRateLimitColor.text = this.$t('rate-limit-warning-medium');
				break;
		}

		this.$nextTick(() => {
			if (this.pageSize.width < 1100 && !this.smallScreen) {
				this.drawer = false;
				this.smallScreen = true;
			}
		});
	},
	methods: {
		...mapActions({
			getPccRateLimits: 'pcc/getPccRateLimits',
		}),
		openOnBoardingDialog () {
			this.showWizard = true;
		},
		closeOnBoardingDialog () {
			this.showWizard = false;
		},
		redirectToPDFManual () {
			const pdfURL = 'https://www.wellnessmetric.net/wmWebManual.pdf';
			window.open(pdfURL, '_blank');
		},
		reloadComponent () {
			const currentPath = this.$route.path;
			const currentName = this.$route.name;

			if (currentName !== 'Patient Details') {
				this.$router.push('/emptyComponent').then(() => {
					this.$router.push({ path: currentPath, query: { reload: new Date().getTime() } });
				});
			} else {
				this.$router.push('/patients');
			}
		},
		logout () {
			this.$router.push({ name: 'Login' });
		},
		drawerClass (item) {
			const classes = [];
			if (this.$route.path === item.path) {
				classes.push('selected-item');
			}
			if (item.path === '/dashboard') {
				if (item.path.substring(1) === this.$route.name.toLowerCase()) {
					classes.push('layout-slider-item-active-dashboard');
					classes.push('selected-item');
				} else {
					classes.push('layout-slider-item-deactive');
				}
			} else {
				if (this.$route.name === 'Patient Details') {
					if (item.path.substring(1) === 'patients') {
						classes.push('layout-slider-item-active-dashboard');
						classes.push('selected-item');
					} else {
						classes.push('layout-slider-item-deactive');
					}
				} else if (['/wellnessassessments'].includes(item.path)) {
					// Check if the current route path matches one of the specified paths
					if (this.$route.path === item.path) {
						classes.push('selected-item');
					}
				} else if (['/organizations', '/offices', '/oareports', '/sareports'].includes(item.path)) {
					// Check if the current route path matches one of the specified paths
					if (this.$route.path === item.path) {
						classes.push('selected-item');
					}
				} else {
					if (item.path.substring(1) === this.$route.name.split(' ').join('').toLowerCase()) {
						classes.push('layout-slider-item-active');
						classes.push('selected-item');
					} else {
						classes.push('layout-slider-item-deactive');
					}
				}
			}
			return classes.join(' ');
		},
		getColorByPercentage () {
			if (this.$store.state.pcc?.isPCCDisabled || !this.$store.state.pcc.rateLimits) return { color: 'red' };
			if (!this.$store.state.pcc?.isPCCDisabled && this.$store.state.pcc.rateLimits.dailyLimit === 0) {
				return { color: 'green' };
			}
			const { dailyPercentage, minutePercentage } = this.$store.state.pcc.rateLimits;

			const rateLimits = this.$store.state.pcc.rateLimits;
			const dailyThresholds = [
				[51, 'green'],
				[26, 'yellow'],
				[10, 'orange'],
				[0, 'red'],
			];

			const minuteThresholds = [
				[51, 'green'],
				[26, 'yellow'],
				[5, 'orange'],
				[0, 'red'],
			];

			const pick = (percentage, thresholds) => thresholds.find(([limit]) => percentage * 100 >= limit)?.[1];

			const dailyColor = pick(dailyPercentage, dailyThresholds);
			const minuteColor = pick(minutePercentage, minuteThresholds);

			return {
				daily: `${this.$t('daily')} ${this.$t('remaining')}: ${rateLimits.dailyRemaining.toLocaleString()} ${this.$t(
					'of',
				)} ${rateLimits.dailyLimit.toLocaleString()}`,
				minute: `${this.$t('Minute')} ${this.$t('remaining')}: ${rateLimits.minuteRemaining.toLocaleString()} ${this.$t(
					'of',
				)} ${rateLimits.minuteLimit.toLocaleString()}`,
				color: dailyPercentage <= minutePercentage ? dailyColor : minuteColor,
			};
		},
	},
	watch: {
		pageSize (val) {
			if (val.width < 1100 && !this.smallScreen) {
				this.drawer = false;
				this.smallScreen = true;
			}
			if (val.width >= 1100 && this.smallScreen) {
				this.smallScreen = false;
			}
		},
		'$store.state.pcc.rateLimits': {
			immediate: false,
			deep: true,
			async handler (value) {
				this.getColorByPercentage();
				const checkRoutes = ['/residentMappingPcc', '/organizationMappingPcc', '/pccLocationMapping'];
				if (this.$store.state.pcc?.isPCCDisabled && checkRoutes.includes(this.$route.path)) {
					showErrorAlert('PCC reached the limit. You will be redirected to main page in 10 seconds', 3);
					setTimeout(() => {
						this.$router.push('/dashboardFacility');
					}, 10 * 1000);
				}
			},
		},
	},
};
</script>

<style>
.custom-list-group .v-list-group__header .v-icon {
	color: white !important;
}
.v-list-group__append-icon {
	color: white !important;
}
</style>
<style lang="scss" scoped>
.no-padding-header {
	padding-right: 4px !important;
}
.no-padding-header :deep(.v-list-group__header) {
	padding: 0 !important;
}
.long-text-group :deep(.v-list-group__header__append-icon) {
	min-width: 0 !important;
}
</style>
